import { render, staticRenderFns } from "./NewsCenterDetails3.vue?vue&type=template&id=62f003ca&scoped=true"
import script from "./NewsCenterDetails3.vue?vue&type=script&lang=js"
export * from "./NewsCenterDetails3.vue?vue&type=script&lang=js"
import style0 from "./NewsCenterDetails3.vue?vue&type=style&index=0&id=62f003ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f003ca",
  null
  
)

export default component.exports